import { render } from "./SignUpButton.vue?vue&type=template&id=e984f3fe"
import script from "./SignUpButton.vue?vue&type=script&lang=js"
export * from "./SignUpButton.vue?vue&type=script&lang=js"
script.render = render

export default script